import { LogType } from "@/helpers/EnumHelpers";

export class ChangeLogEntryData {
  public description: string;
  public type: LogType;
  public toolId: string;
  public toolName: string;

  constructor(
    pType: LogType,
    pDescription: string,
    ptoolId: string,
    pToolName: string
  ) {
    this.description = pDescription;
    this.type = pType;
    this.toolId = ptoolId;
    this.toolName = pToolName;
  }
}
